import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated `/trades/bid-packages/*` URLs.
 *
 * Kept separate from `bidPackages.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Nested routes compose from their parent's `.path` so the hierarchy stays visible and absolute
 * strings stay in sync (RR6 requires a child's path to start with its parent's).
 */
export const bidPackagesRoute = defineRoute("/trades/bid-packages");

/**
 * `add`/`:idOrAdd`-style route kept only for `createBidPackageUrl`'s URL generation; every real
 * caller passes `idOrAdd = "add"`, which `bidPackageCreateRoute` (a plain static route) already
 * matches with higher specificity, so this is never registered in the route tree.
 */
export const bidPackageRoute = defineRoute(`${bidPackagesRoute.path}/:idOrAdd`);
export const bidPackageCreateRoute = defineRoute(`${bidPackagesRoute.path}/add`);
export const bidPackageEditRoute = defineRoute(`${bidPackagesRoute.path}/edit/:bidPackageGroupId`);
export const bidPackageDetailsRoute = defineRoute(`${bidPackagesRoute.path}/:bidPackageGroupId/:bidPackageId`);

const planBasedBidPackageRoute = defineRoute(`${bidPackagesRoute.path}/plan-based-bid-package`);
export const planBasedBidPackageCreateRoute = defineRoute(`${planBasedBidPackageRoute.path}/add`);
export const planBasedBidPackageEditRoute = defineRoute(`${planBasedBidPackageRoute.path}/edit/:bidPackageGroupId`);
// `:bidderId` is a `BidPackageBidder.id`, which the backend sets to the underlying
// `BidPackageRequest.id` (bpr:) for trade-partner bidders and the `BidContract.id` (bc:)
// for the internal-estimate bidder. Keep this regex in sync with that invariant.
export const enterPlanBasedBidRoute = defineRoute(`${planBasedBidPackageRoute.path}/:bidPackageId/enter-bid/:bidderId`);
